// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/i18n'; // 记得引入你的 i18n 配置文件
Vue.use(VueRouter)

// SEO meta description 管理
function setMetaDescription(description) {
  let meta = document.querySelector('meta[name="description"]')
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', 'description')
    document.head.appendChild(meta)
  }
  meta.setAttribute('content', description)
}

const routes = [ {
    path: '/',
    name: 'NewHome',
    component: () => import('../views/NewHome.vue'),
    meta: {
      title: 'metaOption.homepage',
      description: 'Ni Hao China! Tenghai Tour is a professional China DMC offering China Custom Travel, China Inbound Tour, China Group Tour Ground Handling. Explore Beijing, Shanghai, Zhangjiajie Avatar Mountains, Future Shenzhen, China Pandas tours. China Family Travel, China Visa-Free Travel Guide.',
      hideHeader: true, hideFooter: false, requiresAuth: false
    }
  },
  {
    path: '/Home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'metaOption.homepage',
      description: 'Explore our China tour packages: Beijing Classic China, Shanghai First Trip, Zhangjiajie Avatar Mountains tours, Yunnan Slow Travel, Hong Kong Shenzhen Guangzhou Tour. Customizable itineraries for every traveler.',
      hideHeader: false, hideFooter: false, requiresAuth: false
    }
  },
  {
    path: '/TravelNotes',
    name: 'TravelNotes',
    component: () => import('@/views/TravelNotes.vue'),
    meta: {
      title: 'metaOption.travelNotes',
      description: 'Popular China travelogues and travel stories shared by travellers — Beijing, Shanghai, Zhangjiajie, Yunnan and more, from our China DMC ground team.',
      hideHeader: false, hideFooter: false, requiresAuth: false
    }
  },
  {
    path: '/TravelNoteDetail',
    name: 'TravelNoteDetail',
    component: () => import('@/views/TravelNoteDetail.vue'),
    meta: {
      title: 'metaOption.travelNoteDetail',
      description: 'China travelogue detail — read the full travel story shared by our travellers and China DMC ground team.',
      hideHeader: false, hideFooter: false, requiresAuth: false
    }
  },
  {
    path: '/LineType',
    name: 'LineType',
    component: () => import('@/views/LineType.vue'),
    meta: {
      title: 'metaOption.route_types',
      description: 'Browse China tour categories: family tours, student study tours, senior tour packages, Muslim-friendly tours, MICE business visits, high-speed rail tours, and custom travel itineraries.',
      hideHeader: false, hideFooter: false, requiresAuth: false
    }
  },
  {
    path: '/LineList',
    name: 'LineList',
    component: () => import('@/views/LineList.vue'),
    meta: {
      title: 'metaOption.route_list',
      description: 'Search China tour packages by destination, date, and duration. Find 8-day China itineraries, Beijing classic tours, Shanghai first trips, Guangzhou Shenzhen Hong Kong Macau tours.',
      hideHeader: false, hideFooter: false, requiresAuth: false
    }
  },
  {
    path: '/SearchPage',
    name: 'SearchPage',
    component: () => import('@/views/SearchPage.vue'),
    meta: {
      title: 'metaOption.search_results',
      description: 'Search results for China tours and travel packages.',
      hideHeader: false, hideFooter: false, requiresAuth: false
    }
  },
  {
    path: '/LineDetail',
    name: 'LineDetail',
    component: () => import('@/views/LineDetail.vue'),
    meta: {
      title: 'metaOption.route_details',
      description: 'Detailed China tour itinerary with pricing, accommodation, transportation, and daily schedule.',
      hideHeader: false, hideFooter: false, requiresAuth: false
    }
  },
  {
    path: '/UserPage',
    name: 'UserPage',
    component: () => import('../views/UserPage.vue'),
    meta: {
      title: 'metaOption.personal_center',
      description: 'Your Tenghai Tour personal center - manage bookings and travel registrations.',
      hideHeader: true, hideFooter: true, requiresAuth: true
    }
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: 'metaOption.login_registr',
      description: 'Login or register for Tenghai Tour - your China DMC and travel partner.',
      hideHeader: true, hideFooter: true, requiresAuth: false
    }
  },
  {
    path: '/richTextPage',
    name: 'richTextPage',
    component: () => import('@/views/richTextPage.vue'),
    meta: {
      title: 'metaOption.Travel',
      description: 'China travel guides: China Visa-Free Travel Guide, China High-Speed Rail Guide, Payment in China for Foreigners, China Travel FAQ, Becoming Chinese cultural guide, and more travel resources.',
      hideHeader: false, hideFooter: false, requiresAuth: false
    }
  },
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',  // 打包改为 hash 模式
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // 获取登录状态（通常存在 localStorage 或 Vuex/Pinia 中）
  const isLoggedIn = localStorage.getItem('token') // 或者根据你的实际存储方式

  // 设置页面标题
  if (to.meta.title) {
    document.title = i18n.t(to.meta.title) // 使用 i18n 进行翻译
  } else {
    document.title = i18n.t('metaOption.defaultTitle') // 你的默认标题
  }
  if (to.query.meta_title) {
    document.title = to.query.meta_title
  }

  // 设置 meta description
  if (to.meta.description) {
    setMetaDescription(to.meta.description)
  }

  // 判断目标路由是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({
        path: '/Login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
